import React from "react";

import { css } from "@emotion/core";
import MoonLoader from "react-spinners/MoonLoader";

export default (props) => (
  <>
    {props.loading ? (
      <MoonLoader
        css={
          css`
            display: block;
            margin: ${props.margin} auto;
          `
        }
        size={props.size}
        color={props.color}
        loading={props.loading}
      />
    ) : null}
  </>
);
